import NavBar from '../../components/nav-bar/nav-bar'
import translate from '../../i18n'
import { Space } from 'antd'
import { Outlet, useLocation } from 'react-router-dom'

const VersionsContainer = () => {
  const location = useLocation()
  const title = location.pathname.match(/^\/versions\/[0-9]+$/)
    ? translate('navBar.viewVersionTitle')
    : translate('navBar.versionsTitle')

  return (
    <Space className="dashboard-wrapper" orientation="vertical">
      <NavBar title={title} />
      <Outlet />
    </Space>
  )
}

export default VersionsContainer
